import React from "react";
import MainImg from "../../../assets/illustrations2/PNG/exactness_page_v-a_for_super_verified_and_partial_verified.png";

export default function TestimonialOne() {
  return (
    <div className="bg-gray-50 p-8 lg:px-20">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10 lg:mt-12 mt-5">
        <div
          className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-2`}
        >
          <img
            src={MainImg}
            alt="Expanded section preview"
            className="md:w-full w-96"
          />
        </div>

        <div className={`text-left md:w-[55%] md:order-1 lg:mt-10 md:p-6`}>
          <p className="text-[22px] my-6 lg:mb-8">
            Make networking and outreach easier with our Chrome extension. Visit
            any LinkedIn profile, personal or company, and get verified email
            addresses instantly.
          </p>
        </div>
      </div>
    </div>
  );
}
